<template>
  <div>
    <div class="myTop">
      <el-breadcrumb style="line-height: 60px;margin-left: 30px;" separator="/">
        <el-breadcrumb-item :to="{ path: '/equipmentManager/equipmentTypeManager' }">设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>设备分类</el-breadcrumb-item>
        <el-button type="primary" class="myBtn">保存</el-button>
      </el-breadcrumb>
    </div>

    <div style="position:relative;left:10px;top: 10px">
      <div
        style="width:250px;display:flex;height:40px;background:#fff;justify-content: space-between;line-height:40px;align-items: center;"
      >
        <span style="margin-left:20px;font-size:22px">分类</span>
        <i class="el-icon-plus" style="font-size:22px;margin-right:10px" @click="addClass"></i>

        <el-dialog title="添加分类" :visible.sync="dialogVisible" width="30%">
          <el-form :model="myform" ref="myform">
            <el-form-item label="分类名称">
              <el-input v-model="myform.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false;submitClass('myform')">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <el-collapse v-model="activeName" @change="changeClassId()" accordion>
        <el-collapse-item
          :title="item.className"
          :key="index"
          v-for="(item,index) in getInfo"
          :name="index"
        >
          <div style="position:absolute">
            <i class="el-icon-delete delIcon" @click="handleDelClass(item.id)"></i>
            <i class="el-icon-more moreIcon" @click="handleChangeClass(item.id,index)"></i>
          </div>
        </el-collapse-item>
      </el-collapse>

      <div style="width: 83%;position:absolute;top:0;left:260px">
        <el-table :data="tableData" stripe>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="dataType" label="数据类型"></el-table-column>
          <el-table-column prop="width" label="宽度"></el-table-column>
          <el-table-column prop="required" label="是否必填"></el-table-column>
          <el-table-column prop="oper" label="操作">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <div slot="reference" class="name-wrapper">
                  <el-link
                    type="primary"
                    @click="handleChangeInfo(scope.row.id,scope.row);dialogFormVisible=true"
                  >编辑</el-link>｜
                  <el-link type="primary" @click="handleDelInfo(scope.row.id)">删除</el-link>
                </div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div style="background-color: #efefef;
		padding: 18px !important;">
          <el-button class="setAdd" @click="handleAddInfo" style="width: 100%">添加</el-button>
        </div>
      </div>
      <el-dialog title="添加" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="数据类型">
            <el-select v-model="form.dataType" placeholder="数据类型">
              <el-option :key="1" label="文本" value="文本"></el-option>
              <el-option :key="2" label="数字" value="数字"></el-option>
              <el-option :key="3" label="时间" value="时间"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="宽度">
            <el-input v-model="form.width"></el-input>
          </el-form-item>
          <el-form-item label="是否必填">
            <el-select v-model="form.required" placeholder="是否必填">
              <el-option :key="true" label="是" value="1"></el-option>
              <el-option :key="false" label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false;submitForm('form')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ifcalssadd: true,
      dialogVisible: false,
      activeName: "0",
      dialogFormVisible: false,
      currentId: "",
      showablData: "",
      form: {
        name: "",
        dataType: "",
        width: "",
        required: "",
      },
      myform: {
        name: "",
      },
      getInfo: [],
      ifadd: true,
      classId: "1",
      formLabelWidth: "120px",
      tableData: [
        {
          name: "王小虎",
          dataType: "文本",
          width: 100,
          required: "必填",
        },
      ],
    };
  },
  methods: {
    handleChange(id, row) {
      console.log(id);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ifadd) {
            let arr = this.$refs[formName].$options.propsData.model;
            let req = null;
            if (arr.required == "是" || arr.required == "1") {
              req = 1;
            } else if (arr.required == "否" || arr.required == "0") {
              req = 0;
            }
            let formdata = new FormData();
            formdata.append("name", arr.name);
            formdata.append("dataType", arr.dataType);
            formdata.append("width", arr.width);
            formdata.append("required", req);
            formdata.append("classId", this.classId);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").adddeviceClass
              )
              .openLoad()
              .startPost(formdata)
              .then((res) => {
                if (res.result == "success") {
                  this.getdeviceClass();
                  this.tableData = this.getInfo[
                    this.activeName
                  ].deviceClassDetailVos;
                }
              });
          } else if (!this.ifadd) {
            let arr = this.$refs[formName].$options.propsData.model;
            let req = null;
            if (arr.required == "是" || arr.required == "1") {
              req = "1";
            } else if (arr.required == "否" || arr.required == "0") {
              req = "0";
            }
            let formdata = new FormData();
            formdata.append("name", arr.name);
            formdata.append("dataType", arr.dataType);
            formdata.append("width", arr.width);
            formdata.append("required", req);
            formdata.append("id", this.currentId);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").changedeviceClass
              )
              .openLoad()
              .startPost(formdata)
              .then((res) => {
                this.getdeviceClass();
                this.tableData = this.getInfo[
                  this.activeName
                ].deviceClassDetailVos;
              });
          }
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    submitClass(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ifcalssadd) {
            let className = this.$refs[formName].$options.propsData.model.name;
            let formdata = new FormData();
            formdata.append("className", className);
            this.componentsMoudel.httpRequest
              .getRequestHander(this.componentsMoudel.getData("urls").addClass)
              .openLoad()
              .startPost(formdata)
              .then((res) => {
                if (res.result == "success") {
                  this.getdeviceClass();
                }
              });
          } else {
            let className = this.$refs[formName].$options.propsData.model.name;
            let formdata = new FormData();
            formdata.append("className", className);
            formdata.append("id", this.classId);

            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").changeClass
              )
              .openLoad()
              .startPost(formdata)
              .then((res) => {
                this.getdeviceClass();
                this.tableData = this.getInfo[
                  this.activeName
                ].deviceClassDetailVos;
              });
          }
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    handleAddInfo() {
      this.ifadd = true;
      this.form = {
        name: "",
        dataType: "",
        width: "",
        required: null,
      };
      this.dialogFormVisible = true;
    },
    getdeviceClass() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getdeviceClass)
        .openLoad()
        .startGet()
        .then((res) => {
          this.getInfo = res.body.data;
          this.tableData = res.body.data[0].deviceClassDetailVos;
          this.tableData = this.getInfo[this.activeName].deviceClassDetailVos;

          res.body.data.forEach((item) => {
            this.tableData.forEach((items, indexs) => {
              if (items.required == "1") {
                this.tableData[indexs].required = "是";
              } else if (items.required == "0") {
                this.tableData[indexs].required = "否";
              }
            });
          });
          this.classId = res.body.data[0].id;
        });
    },
    //删除详细信息
    handleDelInfo(id) {
      // console.log(id);
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").deldeviceClass + id
        )
        .openLoad()
        .startDel()
        .then((res) => {
          if (res.result == "success") {
            this.getdeviceClass();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        });
    },

    handleChangeInfo(id, row) {
      this.ifadd = false;
      this.currentId = id;
      this.form = {
        name: row.name,
        dataType: row.dataType,
        width: row.width,
        required: row.required,
      };
    },
    handleChangeClass(id, index) {
      this.ifcalssadd = false;
      this.dialogVisible = true;
      this.myform.name = this.getInfo[index].className;
    },
    handleDelClass(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").delClass + id)
        .openLoad()
        .startDel()
        .then((res) => {
          if (res.result == "success") {
            this.getdeviceClass();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        });
    },
    //添加分类信息
    addClass() {
      this.ifcalssadd = true;
      this.dialogVisible = true;
      this.myform = {
        name: "",
      };
    },
    changeClassId() {
      this.classId = this.getInfo[this.activeName].id;
      this.tableData = this.getInfo[this.activeName].deviceClassDetailVos;
    },
  },
  created() {
    this.getdeviceClass();
  },
};
</script>

<style>
.myTop {
  background-color: #ffffff;
  width: 89%;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
}
.myBtn {
  position: absolute;
  top: 10px;
  right: 30px;
}
.el-collapse {
  width: 250px;
  height: 850px;
  padding-left: 20px;
  background-color: #fff;
}
.delIcon {
  position: absolute;

  bottom: -10px;
  left: 200px;
}
.moreIcon {
  position: absolute;
  bottom: -10px;
  left: 160px;
}
.setAdd {
  width: 86%;
  height: 28px !important;
  display: block;
  border: 1px dashed #e9eef3;
  margin: 0 auto;
  line-height: 8px !important;
}
</style>
